import React from "react";
import PropTypes from "prop-types";
import CustomButton from "../../../../../../components/common/buttons/custom-button/custom-button";
import clsx from "clsx";

const FormNavigation = ({ onBack, submitText, onSubmit, isFirstStep, disabled }) => {
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit();
    };

    return (
        <div className="tw-flex tw-justify-between tw-gap-4">
            <CustomButton
                className="tw-flex-1 tw-bg-[#FFF7ED] tw-text-[#F69929] tw-rounded-[8px] tw-py-2 tw-font-semibold"
                text="Back"
                handleClick={onBack}
                type="button"
            />
            <CustomButton
                className={clsx(
                    "tw-flex-1 tw-bg-[#F69929] tw-text-white tw-rounded-[8px] tw-py-2 tw-font-semibold",
                    disabled && "tw-opacity-50 tw-cursor-not-allowed"
                )}
                text={submitText}
                handleClick={handleSubmit}
                type="button"
                isDisabled={disabled}
            />
        </div>
    );
};

FormNavigation.propTypes = {
    onBack: PropTypes.func.isRequired,
    submitText: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isFirstStep: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
};

export default FormNavigation;
